module.exports = __webpack_public_path__ + "static/media/kishoriWebV3.1a0039b6.png";